import { createSlice } from '@reduxjs/toolkit';

export const answerSlice = createSlice({
    name: 'answer',
    initialState: {
        data: null,
    },
    reducers: {
        setAnswer: (state, {payload}) => {
            state.data = payload;
        }
    },
});

export const {
    setAnswer,
} = answerSlice.actions;

export default answerSlice.reducer;
